import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import projImg1 from "../assets/img/mario-jump.png";
import projImg3 from "../assets/img/Pokedex.png";
import projImg4 from "../assets/img/bibliotech.png";
import projImg5 from "../assets/img/digital-piano.png";
import projImg6 from "../assets/img/tlrwa.png";
import projImg7 from "../assets/img/ecoloja.png";
import projImg8 from "../assets/img/Calculator.png";
import projImg9 from "../assets/img/ulfd.png";
import projImg10 from "../assets/img/tlrd.png";
import projImg11 from "../assets/img/soulpet-front.png";
import projImg12 from "../assets/img/soulpet-back.png";
import projImg13 from "../assets/img/class-api.png";
import projImg14 from "../assets/img/sales-api.png";
import projImg15 from "../assets/img/soultask.png";
import projImg16 from "../assets/img/sales-api-bootcamp.png";

import colorSharp2 from "../assets/img/color-sharp2.png";
import "animate.css";
import TrackVisibility from "react-on-screen";

export const Projects = () => {
    const projects = [
        {
            title: "Useful Links for Web Developers",
            description: "Design & Development",
            subdescription: "HTML and CSS",
            imgUrl: projImg9,
            linkUrlPage: "https://useful-links-for-devs.vercel.app/",
            linkUrlGitHub: "https://github.com/eujoaolima/useful-links",
        },
        {
            title: "Mario Jump",
            description: "Design & Development",
            subdescription: "HTML, CSS and JavaScript",
            imgUrl: projImg1,
            linkUrlPage: "https://mario-jump-psi.vercel.app",
            linkUrlGitHub: "https://github.com/eujoaolima/Mario-Jump",
        },
        {
            title: "Clothes Store - Prototype Version",
            description: "Design and Development",
            subdescription: "HTML and CSS",
            imgUrl: projImg7,
            linkUrlPage: "https://eujoaolima.github.io/Ecoloja/",
            linkUrlGitHub: "https://github.com/eujoaolima/Ecoloja",
        },
        {
            title: "Pokédex",
            description: "Design & Development",
            subdescription: "HTML, CSS, JavaScript and PokéAPI",
            imgUrl: projImg3,
            linkUrlPage: "https://eujoaolima.github.io/pokedex/",
            linkUrlGitHub: "https://github.com/eujoaolima/pokedex",
        },
        {
            title: "Digital Piano",
            description: "Design & Development",
            subdescription: "HTML, CSS and JavaScript",
            imgUrl: projImg5,
            linkUrlPage: "https://eujoaolima.github.io/digital-piano/",
            linkUrlGitHub: "https://github.com/eujoaolima/digital-piano",
        },
        {
            title: "Restaurant App - Prototype Version",
            description: "Development",
            subdescription: "React.js, Typescript and TailwindCSS",
            imgUrl: projImg6,
            linkUrlPage: "https://littlelemon-app.vercel.app/",
            linkUrlGitHub: "https://github.com/eujoaolima/Littlelemon-App",
        },
        {
            title: "Calculator App",
            description: "Design & Development",
            subdescription: "React.js",
            imgUrl: projImg8,
            linkUrlPage: "https://calculator-app-eujoaolima.vercel.app",
            linkUrlGitHub: "https://github.com/eujoaolima/Calculator-App",
        },
        {
            title: "Bibliotech",
            description: "Design and Development",
            subdescription: "React.js and Firebase",
            imgUrl: projImg4,
            linkUrlPage: "https://bibliotech-squad8.vercel.app/cadastro",
            linkUrlGitHub: "https://github.com/eujoaolima/bibliotech",
        },
        {
            title: "Restaurant App - Prototype Version",
            description: "Design",
            subdescription: "Figma",
            imgUrl: projImg10,
            linkUrlPage:
                "https://www.figma.com/proto/zLPTXAaHKGkd6v9ahOwJqj/Little-Lemon-Website---Capstone?node-id=0%3A1&scaling=min-zoom&page-id=0%3A1",
            linkUrlGitHub:
                "https://drive.google.com/drive/folders/1Ew9O8gAPqvHNmMSqRmeY00fRPFuo370B?usp=share_link",
        },
        {
            title: "SoulPet App",
            description: "Design and Development",
            subdescription: "React-Bootstrap",
            imgUrl: projImg11,
            linkUrlPage: "https://github.com/eujoaolima/soulpet-front-1",
            linkUrlGitHub: "https://github.com/eujoaolima/soulpet-front-1",
        },
        {
          title: "SoulPet API",
          description: "Design & Development",
          subdescription: "NodeJS, MySQL, Sequelize, Cors, dotenv and Joi",
          imgUrl: projImg12,
          linkUrlPage: "https://github.com/eujoaolima/soulpet-back",
          linkUrlGitHub: "https://github.com/eujoaolima/soulpet-back",
      },
      {
          title: "Sales API",
          description: "Design & Development",
          subdescription: "Java, Spring Boot and Hibernate",
          imgUrl: projImg14,
          linkUrlPage:
              "https://github.com/eujoaolima/java-springboot-vendas-api",
          linkUrlGitHub:
              "https://github.com/eujoaolima/java-springboot-vendas-api",
      },
      {
          title: "Sales API (V2)",
          description: "Design & Development",
          subdescription: "NodeJS, MongoDB, Mongoose and Swagger",
          imgUrl: projImg16,
          linkUrlPage: "https://github.com/eujoaolima/atividade-node-mongodb",
          linkUrlGitHub:
              "https://github.com/eujoaolima/atividade-node-mongodb",
      },
      {
          title: "Class API",
          description: "Design & Development",
          subdescription: "NodeJS, MySQL, Sequelize and Swagger",
          imgUrl: projImg13,
          linkUrlPage: "https://github.com/eujoaolima/atividade-node-mongodb",
          linkUrlGitHub:
              "https://github.com/eujoaolima/atividade-node-mongodb",
      },
      {
          title: "SoulTask API",
          description: "Design & Development",
          subdescription: "NodeJS, MongoDB and Mongoose",
          imgUrl: projImg15,
          linkUrlPage: "https://github.com/eujoaolima/soultask",
          linkUrlGitHub: "https://github.com/eujoaolima/soultask",
      },
    ];

    const WebAppProject = [
        {
            title: "Useful Links for Web Developers",
            description: "Design & Development",
            subdescription: "HTML and CSS",
            imgUrl: projImg9,
            linkUrlPage: "https://useful-links-for-devs.vercel.app/",
            linkUrlGitHub: "https://github.com/eujoaolima/useful-links",
        },
        {
            title: "Mario Jump",
            description: "Design & Development",
            subdescription: "HTML, CSS and JavaScript",
            imgUrl: projImg1,
            linkUrlPage: "https://mario-jump-psi.vercel.app",
            linkUrlGitHub: "https://github.com/eujoaolima/Mario-Jump",
        },
        {
            title: "Clothes Store - Prototype Version",
            description: "Design and Development",
            subdescription: "HTML and CSS",
            imgUrl: projImg7,
            linkUrlPage: "https://eujoaolima.github.io/Ecoloja/",
            linkUrlGitHub: "https://github.com/eujoaolima/Ecoloja",
        },
        {
            title: "Pokédex",
            description: "Design & Development",
            subdescription: "HTML, CSS, JavaScript and PokéAPI",
            imgUrl: projImg3,
            linkUrlPage: "https://eujoaolima.github.io/pokedex/",
            linkUrlGitHub: "https://github.com/eujoaolima/pokedex",
        },
        {
            title: "Digital Piano",
            description: "Design & Development",
            subdescription: "HTML, CSS and JavaScript",
            imgUrl: projImg5,
            linkUrlPage: "https://eujoaolima.github.io/digital-piano/",
            linkUrlGitHub: "https://github.com/eujoaolima/digital-piano",
        },
        {
            title: "Restaurant App - Prototype Version",
            description: "Development",
            subdescription: "React.js, Typescript and TailwindCSS",
            imgUrl: projImg6,
            linkUrlPage: "https://littlelemon-app.vercel.app/",
            linkUrlGitHub: "https://github.com/eujoaolima/Littlelemon-App",
        },
        {
            title: "SoulPet App",
            description: "Design and Development",
            subdescription: "React-Bootstrap",
            imgUrl: projImg11,
            linkUrlPage: "https://github.com/eujoaolima/soulpet-front-1",
            linkUrlGitHub: "https://github.com/eujoaolima/soulpet-front-1",
        },
    ];

    const UIUXProject = [
        {
            title: "Restaurant App - Prototype Version",
            description: "Design",
            subdescription: "Figma",
            imgUrl: projImg10,
            linkUrlPage:
                "https://www.figma.com/proto/zLPTXAaHKGkd6v9ahOwJqj/Little-Lemon-Website---Capstone?node-id=0%3A1&scaling=min-zoom&page-id=0%3A1",
            linkUrlGitHub:
                "https://drive.google.com/drive/folders/1Ew9O8gAPqvHNmMSqRmeY00fRPFuo370B?usp=share_link",
        },
    ];

    const ReactProject = [
        {
            title: "Calculator App",
            description: "Design & Development",
            subdescription: "React.js",
            imgUrl: projImg8,
            linkUrlPage: "https://calculator-app-eujoaolima.vercel.app",
            linkUrlGitHub: "https://github.com/eujoaolima/Calculator-App",
        },
        {
            title: "Restaurant App - Prototype Version",
            description: "Development",
            subdescription: "React.js, Typescript and TailwindCSS",
            imgUrl: projImg6,
            linkUrlPage: "https://littlelemon-app.vercel.app/",
            linkUrlGitHub: "https://github.com/eujoaolima/Littlelemon-App",
        },
        {
            title: "SoulPet App",
            description: "Design and Development",
            subdescription: "React-Bootstrap",
            imgUrl: projImg11,
            linkUrlPage: "https://github.com/eujoaolima/soulpet-front-1",
            linkUrlGitHub: "https://github.com/eujoaolima/soulpet-front-1",
        },
    ];

    const ApiProject = [
        {
            title: "SoulPet API",
            description: "Design & Development",
            subdescription: "NodeJS, MySQL, Sequelize, Cors, dotenv and Joi",
            imgUrl: projImg12,
            linkUrlPage: "https://github.com/eujoaolima/soulpet-back",
            linkUrlGitHub: "https://github.com/eujoaolima/soulpet-back",
        },
        {
            title: "Sales API",
            description: "Design & Development",
            subdescription: "Java, Spring Boot and Hibernate",
            imgUrl: projImg14,
            linkUrlPage:
                "https://github.com/eujoaolima/java-springboot-vendas-api",
            linkUrlGitHub:
                "https://github.com/eujoaolima/java-springboot-vendas-api",
        },
        {
            title: "Sales API (V2)",
            description: "Design & Development",
            subdescription: "NodeJS, MongoDB, Mongoose and Swagger",
            imgUrl: projImg16,
            linkUrlPage: "https://github.com/eujoaolima/atividade-node-mongodb",
            linkUrlGitHub:
                "https://github.com/eujoaolima/atividade-node-mongodb",
        },
        {
            title: "Class API",
            description: "Design & Development",
            subdescription: "NodeJS, MySQL, Sequelize and Swagger",
            imgUrl: projImg13,
            linkUrlPage: "https://github.com/eujoaolima/atividade-node-mongodb",
            linkUrlGitHub:
                "https://github.com/eujoaolima/atividade-node-mongodb",
        },
        {
            title: "SoulTask API",
            description: "Design & Development",
            subdescription: "NodeJS, MongoDB and Mongoose",
            imgUrl: projImg15,
            linkUrlPage: "https://github.com/eujoaolima/soultask",
            linkUrlGitHub: "https://github.com/eujoaolima/soultask",
        },
    ];

    return (
        <section className="project" id="myprojects">
            <Container>
                <Row>
                    <Col size={12}>
                        <TrackVisibility>
                            {({ isVisible }) => (
                                <div
                                    className={
                                        isVisible
                                            ? "animate__animated animate__fadeIn"
                                            : ""
                                    }
                                >
                                    <h2>Projects</h2>

                                    <Tab.Container
                                        id="projects-tabs"
                                        defaultActiveKey="first"
                                    >
                                        <Nav
                                            variant="pills"
                                            className="nav-pills mb-5 justify-content-center align-items-center"
                                            id="pills-tab"
                                        >
                                            <Nav.Item>
                                                <Nav.Link eventKey="first">
                                                    All
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="second">
                                                    Apps
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="third">
                                                    UI/UX
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="fourth">
                                                    React.js
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="fifth">
                                                    APIs
                                                </Nav.Link>
                                            </Nav.Item>
                                        </Nav>
                                        <Tab.Content
                                            id="slideInUp"
                                            className={
                                                isVisible
                                                    ? "animate__animated animate__slideInUp"
                                                    : ""
                                            }
                                        >
                                            <Tab.Pane eventKey="first">
                                                <Row>
                                                    {projects.map(
                                                        (project, index) => {
                                                            return (
                                                                <ProjectCard
                                                                    key={index}
                                                                    {...project}
                                                                />
                                                            );
                                                        }
                                                    )}
                                                </Row>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="second">
                                                <Row>
                                                    {WebAppProject.map(
                                                        (
                                                            WebAppProject,
                                                            index
                                                        ) => {
                                                            return (
                                                                <ProjectCard
                                                                    key={index}
                                                                    {...WebAppProject}
                                                                />
                                                            );
                                                        }
                                                    )}
                                                </Row>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="third">
                                                <Row>
                                                    {UIUXProject.map(
                                                        (
                                                            UIUXProject,
                                                            index
                                                        ) => {
                                                            return (
                                                                <ProjectCard
                                                                    key={index}
                                                                    {...UIUXProject}
                                                                />
                                                            );
                                                        }
                                                    )}
                                                </Row>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="fourth">
                                                <Row>
                                                    {ReactProject.map(
                                                        (
                                                            ReactProject,
                                                            index
                                                        ) => {
                                                            return (
                                                                <ProjectCard
                                                                    key={index}
                                                                    {...ReactProject}
                                                                />
                                                            );
                                                        }
                                                    )}
                                                </Row>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="fifth">
                                                <Row>
                                                    {ApiProject.map(
                                                        (ApiProject, index) => {
                                                            return (
                                                                <ProjectCard
                                                                    key={index}
                                                                    {...ApiProject}
                                                                />
                                                            );
                                                        }
                                                    )}
                                                </Row>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Tab.Container>
                                </div>
                            )}
                        </TrackVisibility>
                    </Col>
                </Row>
            </Container>
            <img className="background-image-right" src={colorSharp2}></img>
        </section>
    );
};
